import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { Block } from 'slate';
import { Add as AddIcon } from '../../../../../../editJournal/toolset/assets/icons';
import Actions from '../../../../../../../../../store/actions';
import handleInsertRole from '../utils/insertRole';
import { FormatTypes } from '../../../../../../../../../constants/templateDictionaries';
import scrollToNextSlateNode from '../utils/scrollToNextSlateNode';
import { AddColor } from '../../../../../../../../../styling/theme';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';

const AddWrapper = styled.span`
  pointer-events: auto;
  cursor: pointer;
  margin-left: ${(props) => (props.type === 'personal_link' ? '20px' : '24px')};

  &:hover {
    svg path:first-child {
      fill: #473880;
    }
  }

  ${(props) => {
    const { type } = props;

    if (
      type === 'skill_title' ||
      type === 'publication' ||
      type === 'language' ||
      type === 'personal_link' ||
      type === 'hobbies_and_interests'
    ) {
      return css`
        margin-left: 0px;
      `;
    }

    return css`
      margin-left: 24px;
    `;
  }}
`;

const Add = (props) => {
  const insertRole = (e) => {
    const { userPreferences, setUserPreferences, editor, node, statusBarRef } =
      props;
    handleInsertRole(
      e,
      editor,
      node,
      statusBarRef,
      props,
      userPreferences,
      setUserPreferences,
    );
  };

  const AddItem = (e) => {
    e.preventDefault();
    const { editor, node, statusBarRef } = props;

    let data;

    if (node.type === 'personal_link') {
      data = {
        toExport: true,
        url: null,
        organization: 'others',
      };
    } else {
      data = {
        toExport: true,
        rating: 0,
        maxRating: 5,
      };
    }

    const newItem = Block.create({
      type: node.type,
      data,
      nodes: [
        {
          object: 'text',
          leaves: [{ text: '' }],
        },
      ],
    });

    const {
      value: { focusBlock },
    } = editor;
    editor.moveToEndOfNode(node).insertBlock(newItem);
    const {
      value: { document },
    } = editor;

    if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();

    /**
     * Set document count
     */
    const documentDataJSON = document.data.toJSON();
    const { selectAll } = documentDataJSON;

    editor.setNodeByKey(document.key, {
      data: {
        ...documentDataJSON,
        selectAll: selectAll + 1,
        toExport: true,
      },
    });
    const {
      value: { document: updatedDocument },
    } = editor;
    scrollToNextSlateNode(
      focusBlock,
      statusBarRef,
      updatedDocument,
      null,
      props,
    );
  };

  const {
    node: { type },
  } = props;

  const clickHandler = (e) => {
    if (type === 'skill_title') insertRole(e);
    else AddItem(e);
  };

  return (
    <AddWrapper
      onClick={clickHandler}
      contentEditable={false}
      type={type}
      data-testid={`${type}_add`}
    >
      <AddIcon width="16px" height="16px" color={AddColor} />
    </AddWrapper>
  );
};

Add.propTypes = {
  node: propTypes.objectOf(propTypes.object).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func,
  }).isRequired,
  userPreferences: propTypes.objectOf(propTypes.object).isRequired,
  setUserPreferences: propTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;

  let userPreferences;
  if (formatType === FormatTypes.RESUME) {
    ({ userPreferences } = state.editResumeFormReducer);
  }
  return {
    userPreferences,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUserPreferences: (params) =>
    dispatch(Actions.editDocumentFormActions.updateUserPreferences(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Add);
